/* eslint-disable import/prefer-default-export */
export const arrayContainsSame = (array1, array2) =>
  array1.join(',') === array2.join(',')
